module.exports = __webpack_public_path__ + "static/demo-75c5b2395f634c494e40b8008eef20eb.mp4";